import { render, staticRenderFns } from "./HeartstoneDecks.vue?vue&type=template&id=01ad0dce"
import script from "./HeartstoneDecks.vue?vue&type=script&lang=js"
export * from "./HeartstoneDecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports